import * as React from 'react';

import classes from './LoadMoreTrigger.scss';

type Props = {
  isVisible: boolean;
  triggerRef: React.RefObject<HTMLDivElement>;
};

const LoadMoreTrigger: React.FC<Props> = ({ isVisible, triggerRef }) =>
  isVisible ? (
    <div
      ref={triggerRef}
      className={classes['load-more-trigger']}
    />
  ) : null;

export default LoadMoreTrigger;
